export const STATUS = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'info',
};
export const SUCCESS_AUTO_CLOSE_TIME = 7000;
//# sourceMappingURL=constants.js.map